module.exports = __webpack_public_path__ + "static/img/剪2.74e6ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪2.png
// module id = UTPE
// module chunks = 2